import { RootMutationNames, RootStore } from "@/vuex-store";

function toLogin() {
    RootStore.commit(RootMutationNames.setShowLoginPanel, true);
}

export const UiTools = {
    toLogin,
};
